export function buildUrlQueryParams(baseUrl: string, queryParams: Record<string, string | string[]>): string {
  const params = new URLSearchParams();

  Object.entries(queryParams).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((val) => params.append(key, val));
    } else {
      params.append(key, value);
    }
  });

  return `${baseUrl}?${params.toString()}`;
}
